import React, { useContext, useState } from 'react';
import { View, Text, StyleSheet, Image, TouchableOpacity, Platform, Alert, Modal } from 'react-native';
import { Fonts, Colors } from '../styles/styles.js';
import { AppContext } from '../../AppContext'; 
import Pro from './Pro.js';
import addImage from '../img/icons/add2.png';
import * as Haptic from 'expo-haptics';

// Objeto de traducción
const translate = {
  ESP: {
    ofrece: 'Ofrece un servicio u objeto a la comunidad (¿Qué ofreces?)',
    necesita: 'Añade una demanda de servicio u objeto (Ej. Busco limpiadora del hogar)',
    limiteAlcanzado: 'Has alcanzado el límite de ofertas permitidas para tu tipo de cuenta. Puedes pausar, eliminar ofertas o mejorar tu perfil a PRO.',
    tituloLimiteAlcanzado: 'Límite Alcanzado',
    cerrar: 'Cerrar',
    verPro: 'Mirar ventajas PRO',
  },
  CAT: {
    ofrece: 'Ofereix un servei o objecte a la comunitat (Què ofereixes?)',
    necesita: 'Afegeix una demanda de servei o objecte (Busco persona per a la neteja)',
    limiteAlcanzado: 'Has assolit el límit d\'ofertes permeses per al teu tipus de compte. Pots pausar, eliminar ofertes o millorar el teu perfil a PRO.',
    tituloLimiteAlcanzado: 'Límit Assolit',
    cerrar: 'Tancar',
    verPro: 'Veure avantatges PRO',
  },
  ENG: {
    ofrece: 'Offer a service or object to the community (What do you offer?)',
    necesita: 'Add a need for a service or object (eg: I am looking for cooking classes, etc.)',
    limiteAlcanzado: 'You have reached the limit of offers allowed for your account type. You can pause or delete offers or upgrade your profile to PRO.',
    tituloLimiteAlcanzado: 'Limit Reached',
    cerrar: 'Close',
    verPro: 'View PRO benefits',
  }
};

const FirstOffer = ({ onPress, selectedOption }) => {
  const { userData, language } = useContext(AppContext);
  const [isProVisible, setIsProVisible] = useState(false);
  const [isWebModalVisible, setWebModalVisible] = useState(false);

  const openPro = () => {
    setWebModalVisible(false);
    setIsProVisible(true); 
  };

  const closeModal = () => {
    setIsProVisible(false);
    setWebModalVisible(false);
  };

  const showLimitAlert = () => {
    Alert.alert(
      translate[language].tituloLimiteAlcanzado,
      translate[language].limiteAlcanzado,
      [
        { text: translate[language].verPro, onPress: openPro },
        { text: translate[language].cerrar, onPress: closeModal }
      ]
    );
  };

  const checkOfferLimit = async () => {
    if (Platform.OS !== 'web') {
      // Añade la respuesta háptica al presionar
      await Haptic.impactAsync(Haptic.ImpactFeedbackStyle.Heavy);
    }
    if (selectedOption === 'ofrece') {
      const activeOffers = userData?.data[0]?.mevesOfertes?.filter(offer => offer.situacioOferta === "A").length;
      const maxAllowedOffers = userData?.data[0]?.maxOfertes_Permesses;

      if (activeOffers >= maxAllowedOffers) {
        Platform.OS === 'web' ? setWebModalVisible(true) : showLimitAlert();
      } else {
        onPress();
      }
    } else {
      onPress();
    }
  };

  const WebModal = () => (
    <Modal
      animationType="slide"
      transparent={true}
      visible={isWebModalVisible}
      onRequestClose={closeModal}
    >
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <Text style={styles.modalTitle}>{translate[language].tituloLimiteAlcanzado}</Text>
          <Text style={styles.modalMessage}>{translate[language].limiteAlcanzado}</Text>
          <View style={styles.buttonContainer}>
            <TouchableOpacity style={styles.button} onPress={closeModal}>
              <Text style={styles.buttonText}>{translate[language].cerrar}</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.button} onPress={openPro}>
              <Text style={styles.buttonText}>{translate[language].verPro}</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );

  return (
    <>
      <TouchableOpacity onPress={checkOfferLimit}> 
        <View style={styles.frame}>
          <View style={styles.div}>
            <Text style={styles.textWrapper}>
              {translate[language][selectedOption].split(' (')[0]}
              <Text style={styles.subtitle}>
                {' (' + translate[language][selectedOption].split(' (')[1]}
              </Text>
            </Text>
            <Image source={addImage} style={styles.add} />
          </View>
        </View>
      </TouchableOpacity>
      {Platform.OS === 'web' && <WebModal />}
      <Modal
          animationType="slide"
          transparent={true}
          visible={isProVisible}
          onRequestClose={closeModal}
      >
          <TouchableOpacity
            style={{ flex: 1 }}
            onPress={closeModal}
            activeOpacity={1}
          >
            <Pro closeModal={closeModal} />
          </TouchableOpacity>
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  frame: {
    width: 340, 
    height: 67, 
    marginBottom: 20,
    marginTop: 10,
  },
  div: {
    borderRadius: 16,
    shadowColor: Colors.primary,
    shadowOffset: {
      width: 3, 
      height: 4, 
    },
    shadowOpacity: 0.5,
    shadowRadius: 6,
    height: 67,
    width: 340,
    position: 'relative',
    alignItems: 'center', 
    backgroundColor: Colors.primary,
    ...Platform.select({
      android: {
        elevation: 12, 
      },
    }),
  },
  textWrapper: {
    color: Colors.white,
    ...Fonts.poppinsMedium16,
    lineHeight: 16 * 1.5,
    position: 'absolute',
    top: 9,
    left: 14,
    width: 272,
  },
  subtitle: {
    fontSize: 12,
    lineHeight: 16 * 1.5,
  },
  add: {
    height: 34,
    width: 34,
    position: 'absolute',
    top: 15,
    left: 295,
  },
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
  },
  modalView: {
    backgroundColor: Colors.white,
    borderRadius: 20,
    padding: 20,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: '80%', 
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 15,
    color: Colors.primary, 
  },
  modalMessage: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 20,
    color: Colors.grayDark, 
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
  },
  button: {
    borderRadius: 20,
    paddingVertical: 10,
    paddingHorizontal: 20,
    elevation: 2,
    backgroundColor: Colors.primary, 
    marginHorizontal: 5,
  },
  buttonText: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

export default FirstOffer;
